import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect, getIn } from 'formik';
import { toNumber } from 'lodash-es';
import NumberFormat from 'react-number-format';
import withLabel from '../Label';

import './styles.scss';

export const Numeric = ({
  formik: { values, setFieldValue },
  className,
  disabled,
  name,
  label,
  style,
  id,
  format,
  locale,
  ...rest
}) => {
  const localeProps = {};

  if (locale.startsWith('en')) {
    localeProps.thousandSeparator = true;
    localeProps.decimalSeparator = '.';
  } else if (locale.startsWith('hi') || locale.startsWith('ne') || locale.startsWith('bn') || locale.startsWith('ur')) {
    // Inde (Hindi), Népal (NE), Bangladesh (BN), Pakistan (Urdu)
    localeProps.thousandSeparator = true;
    localeProps.thousandsGroupStyle = 'lakh';
    localeProps.decimalSeparator = '.';
  } else {
    localeProps.thousandSeparator = ' ';
    localeProps.decimalSeparator = ',';
  }

  const formatValue = val => {
    if (locale.startsWith('fr')) {
      return toNumber(`${val}`.replace(',', '.'));
    }
    return val;
  };

  return (
    <div className={cx('form-element', 'numeric-field', className, { isDisabled: disabled })} style={style}>
      <NumberFormat
        {...rest}
        name={name}
        id={id || name}
        onValueChange={({ floatValue }) => setFieldValue(name, floatValue % 1 ? `${floatValue}` : floatValue)}
        value={formatValue(getIn(values, name))}
        disabled={disabled}
        {...localeProps}
      />
    </div>
  );
};

Numeric.propTypes = {
  /** @ignore */
  formik: PropTypes.instanceOf(Object).isRequired,
  /** Adds a custom class to the Numeric button */
  className: PropTypes.string,
  /** Adds a custom inline styles to the Numeric wrapper div */
  style: PropTypes.instanceOf(Object),
  /** Disables the Numeric button */
  disabled: PropTypes.bool,
  /** Sets the Name of the Numeric button */
  name: PropTypes.string.isRequired,
  /** Sets an Id for the Numeric button, if not passed, the id will be the name */
  id: PropTypes.string,
  /** If defined it limits to given decimal scale. default: 2 */
  decimalScale: PropTypes.number,
  /** If true it add 0s to match given decimalScale. default: true */
  fixedDecimalScale: PropTypes.bool,
  /** Value to the number format. It can be a float number, or formatted string. If value is string representation of number (unformatted), isNumericString props should be passed as true. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  /** Value to the used as default value if value is not provided. The format of defaultValue should be similar as defined for the value. */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** allow negative numbers (Only when format option is not provided). default: true */
  allowNegative: PropTypes.bool,
  /** aApply formatting to empty inputs. default: true */
  allowEmptyFormatting: PropTypes.bool,
  /** if input it renders a input element where formatting happens as you input characters. If text it renders it as a normal text in a span formatting the given value */
  displayType: PropTypes.oneOf(['text', 'input']),
  /** Input type attribute */
  type: PropTypes.oneOf(['text', 'tel', 'password']),
  /** A checker function to check if input value is valid or not */
  isAllowed: PropTypes.func,
  label: PropTypes.string,
  format: PropTypes.string,
  locale: PropTypes.string,
};

Numeric.defaultProps = {
  className: null,
  style: null,
  disabled: false,
  id: null,
  decimalScale: 2,
  fixedDecimalScale: false,
  defaultValue: undefined,
  allowNegative: true,
  allowEmptyFormatting: true,
  displayType: 'input',
  type: 'text',
  isAllowed: () => true,
  label: undefined,
  format: undefined,
  locale: 'fr',
};

export default withLabel('numeric')(connect(Numeric));
